// Generate a 6-character alphanumeric invite code
export const generateInviteCode = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let code = '';
  for (let i = 0; i < 6; i++) {
    code += chars[Math.floor(Math.random() * chars.length)];
  }
  return code;
};

export const normalizeInviteCode = (code) => {
  return code.trim().toUpperCase();
};
